import DashboardLayout from '@/views/Layout/DashboardLayout.vue';

// Documents
const DocumentsList = () => import(/* webpackChunkName: "documents" */ '@/views/Documents/List.vue');
const DocumentCreate = () => import(/* webpackChunkName: "documents" */ '@/views/Documents/Create.vue');
const DocumentShow = () => import(/* webpackChunkName: "documents" */ '@/views/Documents/Show.vue');
const Account = () => import(/* webpackChunkName: "dashboard" */ '@/views/Documents/Account.vue');
const Settlement = () => import(/* webpackChunkName: "dashboard" */ '@/views/Documents/Settlement.vue');
const Stock = () => import(/* webpackChunkName: "dashboard" */ '@/views/Documents/Stock.vue');

let documentsPages = {
  path: '/documents',
  redirect: '/documents',
  component: DashboardLayout,
  name: 'Documents',
  meta: {
    title: 'Documentos',
    auth: true,
  },
  children: [
    {
      path: '',
      name: 'DocumentsList',
      meta: {
        title: 'Listado',
        subtitle: 'Documentos cargados',
        type: '',
        entity: '',
        auth: ['documents.index'],
      },
      component: DocumentsList,
    },
    {
      path: 'create',
      name: 'DocumentCreate',
      meta: {
        title: 'Nuevo',
        auth: ['documents.store'],
      },
      component: DocumentCreate,
    },
    {
      path: 'account',
      name: 'AccountDocuments',
      meta: {
        title: 'Cuenta Corriente',
        subtitle: 'Documentos de cuenta corriente cargados',
        type: 'Cuenta Corriente',
        entity: '',
        auth: ['documents.index'],
      },
      component: Account,
    },
    {
      path: 'settlement',
      name: 'SettlementDocuments',
      meta: {
        title: 'Liquidación',
        subtitle: 'Documentos de liquidación cargados',
        type: 'Liquidación',
        entity: '',
        auth: ['documents.index'],
      },
      component: Settlement,
    },
    {
      path: 'stock',
      name: 'StockDocuments',
      meta: {
        title: 'Stock',
        subtitle: 'Documentos de stock cargados',
        type: 'Stock',
        entity: '',
        auth: ['documents.index'],
      },
      component: Stock,
    },
    {
      path: ':type/:id/upload',
      name: 'DocumentUpload',
      meta: {
        title: 'Nuevo',
        auth: ['documents.store'],
      },
      component: DocumentCreate,
    },
    {
      path: ':id',
      name: 'DocumentShow',
      meta: {
        title: 'Detalle',
        auth: ['documents.show'],
      },
      component: DocumentShow,
    },
  ],
};

export default documentsPages;
